module.exports = "/packs/images/pages/gift_cards/gift-card-top~5e5c35399b6f878817da227397a515e2.png";